import React, { Component } from 'react'
import { ButtonContained } from '../app-button/button'
import { withStyles } from '@material-ui/core/styles'
import { withSnackbar } from 'notistack'

const styles = theme => ({
  paymentNowBtn: {
    height: 54,
    marginBottom: 32,
    padding: 0,
  },
  loadData: {
    marginBottom: 32,
    fontSize: 24,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.4)',
  },
})

export class PaymentNow extends Component {
  state = {
    isFetching: false,
    isDisabled: false,
  }

  handlePaymentNow = () => {
    this.setState({
      isFetching: true,
      isDisabled: true,
    })

    const url = '/pay/charge'

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
        isDisabled: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}).
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        if (data) {
          location.reload()
        }
      })
      .catch(message => handleServerError(message))
  }

  render() {
    const { classes } = this.props
    const { isFetching, isDisabled } = this.state

    const paymentNow = (
      <ButtonContained
        full
        onClick={this.handlePaymentNow}
        customClass={classes.paymentNowBtn}
        color="secondary"
        text="Оплатить сейчас"
        disabled={isDisabled}
      />
    )
    const loadData = (
      <div className={classes.loadData}>Ожидание ответа от банка…</div>
    )

    if (isFetching) {
      return loadData
    }

    return paymentNow
  }
}

export default withStyles(styles)(withSnackbar(PaymentNow))
